import { useTracking } from '@change-corgi/core-react/tracking';

import { useTopicPageData } from '#src/app/pages/topic/details/pageContext';
import type { TopicPageData } from '#src/app/pages/topic/details/pageContext';

type Result = ModelHookResult<{
	description: string | null;
	name: string;
	onAccordionToggle: (expanded: boolean, tracking: string) => void;
	structuredData: TopicPageData['structuredData'];
}>;

export function useTopicContentSection(): Result {
	const {
		data: { description, name, structuredData },
	} = useTopicPageData();

	const track = useTracking();

	const handleAccordionToggle = (expanded: boolean, tracking: string) => {
		if (expanded) {
			void track(tracking);
		}
	};

	return {
		data: {
			description,
			name,
			structuredData,
			onAccordionToggle: (expanded: boolean, tracking: string) => handleAccordionToggle(expanded, tracking),
		},
	};
}
